import * as React from 'react';
import { AnyObject } from 'final-form';

interface IFormDebugPanelProps {
    formValues: AnyObject;
}

interface IFormDebugPanelState {
    position: string;
    collapsed: boolean;
}

class FormDebugPanel extends React.Component<IFormDebugPanelProps, IFormDebugPanelState> {
    constructor(props: IFormDebugPanelProps) {
        super(props);

        this.state = {
            position: 'upper-left',
            collapsed: true,
        };
    }

    toggleCollapsed = () => {
        this.setState({ collapsed: !this.state.collapsed });
    };

    public render() {
        return (
            <div className={`form-debug-panel ${this.state.position}`}>
                <div>
                    <button onClick={this.toggleCollapsed}>{this.state.collapsed ? 'expand' : 'collapse'}</button>
                </div>
                <pre className={this.state.collapsed ? 'collapsed' : ''}>{JSON.stringify(this.props.formValues, null, 2)}</pre>
            </div>
        );
    }
}

export default FormDebugPanel;



// WEBPACK FOOTER //
// ./src/components/controls/forms/FormDebugPanel.tsx